import { InputV2 } from "@southfields-digital/mxmz-react-ui";
import classNames from "classnames";
import { useEffect, useState } from "react";

type ShortNameInputProps = {
	value: string;
	onChange: (value: string) => void;
	isCompact?: boolean;
};

const ShortNameInput = ({ value, onChange, isCompact = false }: ShortNameInputProps) => {
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalValue(e.target.value);
	};

	const propagate = (val: string) => {
		if (val !== value) onChange(val);
	};

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		propagate(e.target.value);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") propagate(localValue);
	};

	return (
		<InputV2
			type="text"
			inputSize={isCompact ? "md" : "lg"}
			className={classNames("text-center min-w-0", isCompact ? "text-sm w-9" : "text-lg w-12")}
			value={localValue}
			onChange={handleChange}
			onBlur={handleBlur}
			onKeyDown={handleKeyDown}
		/>
	);
};

export default ShortNameInput;
